export class GetLiveHubConnectionsRequest {
    ActiveConnectionsOnly: boolean;
}
